import {
  getEmailLogsDescription,
  getEmailMigrationLogDescription,
  getMigrationLogsDescription,
  getNewUsersEmailLogsDescription,
  getOnboardingUserLogDescription,
  getUserLogDescription,
  getUserPermissioneLogDescription,
  getVacationLogsDescription,
  getVerifyPhoneLogDescription,
  translateDescription,
} from "@/helpers/services/logs";
import { i18n } from "@/plugins/vue-i18n";

export const expandableContexts = [
  "edit_tags",
  "edit_user_tags",
  "migrate_emails",
  "vacation_apply",
  "vacation_apply_batch",
  "sync_user_data",
];

export const LOG_CONTEXT = {
  USER_PERMISSION: "user_permission",
  COMPANY_PLAN: "company_plan",
  USER_DELEGATES: "user_delegates",
  EDIT_TAGS: "edit_tags",
  EDIT_USER_TAGS: "edit_user_tags",
  VERIFY_PHONE: "verify_phone",
  SYNC_USER_DATA: "sync_user_data",
  user_delegates: "Delegação de acesso",
  edit_tags: "Edição de informações",
  edit_user_tags: "Edição de informações de usuário",
  add_new_user: "Criação de usuário",
  onboarding_new_user: "Criação de usuário",
  update_user: "Atualização de usuário",
  delete_user: "Exclusão de usuário",
  apply_email_signature: "Aplicação de assinatura",
  request_email_signature: "Solicitação de aplicação",
  default_signature_for_new_user: "Assinatura para novos usuários",
  reapply_email_signature: "Reaplicação de assinatura",
  apply_secondary_email_signature:
    "Aplicação de assinatura no email secundário",
  declined_signature: "Aplicação de assinatura",
  accepted_signature: "Aplicação de assinatura",
  verify_phone: "Verificação de telefone",
  new_users_signature: "Assinatura para novos usuários",
  user_permission: "Permissão de usuário",
  migrate_emails: "Migração de e-mails",
  vacation_apply: "Aplicação de férias",
  vacation_apply_batch: "Aplicação de férias",
  sync_user_data: "Sincronização de Usuários",
  stop_migration: i18n.t("reports.context.stopMigration"),
};

export const LOG_TRANSCRIPTION = {
  NEW_USERS_SIGNATURE: " Assinatura para novos usuários",
  EMAIL_SIGNATURE: "assinatura de e-mail",
  APPLY_EMAIL_SIGNATURE: "aplicou assinatura de email",
  USER: "Usuário",
  UPDATED: "Atualizado",
  CREATED: "Criado",
  DELETED: "Excluído",
  user_delegates: "Delegação de acesso",
  edit_tags: "Edição de informações",
  sync_user_data: "Sincronização de usuários",
  edit_user_tags: "Edição de informações de usuário",
  DELETE: "Exclusão de",
  CREATE: "Delegação de",
  ACCESS: " acesso",
  FROM: " da conta ",
  TO: " para",
  EDITED_TAGS: " editou as informações de assinatura da empresa",
  EDITED_USER_TAGS: " editou as informações de assinatura do usuário ",
  SYNC_USER_DATA: "Dados atualizados do usuário ",
  APPLIED: " aplicou",
  NOT_FOUND: "não encontrado",
  None: "Usuário não encontrado",
};

export const LOG_ICON_BY_ACTION = {
  CREATE: "ph-plus-circle",
  DELETE: "ph-minus-circle",
  ADD_USER_PERMISSION: "ph-plus-circle",
  REMOVE_USER_PERMISSION: "ph-minus-circle",
};

export const LOG_ICON_COLOR_BY_ACTION = {
  CREATE: "success",
  DELETE: "error",
  ADD_USER_PERMISSION: "success",
  REMOVE_USER_PERMISSION: "error",
};

export const LOG_ICON_BY_STATUS_CODE = {
  SUCCESS: "ph-fill ph-shield-check",
  EXPIRED_CODE: "ph-fill ph-shield-warning",
  INVALID_CODE: "ph-fill ph-shield-slash",
  UNKNOWN_ERROR: "ph-fill ph-shield-slash",
  SKIP_VERIFICATION: "ph-fill ph-skip-forward",
  TOO_MANY_REQUESTS: "ph-fill ph-clock",
  RUNNING: "ph-spinner",
  IN_PROGRESS: "ph-spinner",
  CANCELED: "ph-minus-circle",
  INTERRUPTED: "ph-stop-circle",
  FINISHED: "ph-fill ph-check",
  COMPLETED: "ph-fill ph-check",
  FAILED: "ph-warning",
};

export const LOG_ICON_COLOR_BY_STATUS_CODE = {
  SUCCESS: "success",
  EXPIRED_CODE: "accent",
  INVALID_CODE: "error",
  UNKNOWN_ERROR: "error",
  TOO_MANY_REQUESTS: "error",
  RUNNING: "primary",
  IN_PROGRESS: "primary",
  CANCELED: "grey",
  INTERRUPTED: "grey",
  FINISHED: "success",
  COMPLETED: "success",
  FAILED: "error",
};

export const LOG_CODE = {
  user_delegates: {
    event: "Delegação de acesso",
    action: "", // Alguns logs tem um único contexto com multiplas ações, portanto utilize a ação do log nesses casos
    icon: "",
    color: "",
    description: "",
    getDescription: translateDescription,
  },

  new_users_signature: {
    event: "Assinatura de novos usuários",
    action: "APPLY",
    icon: "ph-check",
    color: "success",
    description:
      "Os novos usuários receberam uma assinatura de email padrão: {IMPACTED_USERS}",
    getDescription: getNewUsersEmailLogsDescription,
  },

  edit_tags: {
    event: "Edição de informações",
    action: "EDIT_TAGS",
    icon: "ph-pencil-simple",
    color: "accent",
    description: "",
    getDescription: translateDescription,
  },

  edit_user_tags: {
    event: "Edição de informações de usuário",
    action: "EDITED_USER_TAGS",
    icon: "ph-pencil-simple",
    color: "accent",
    description: "",
    getDescription: translateDescription,
  },

  apply_email_signature: {
    event: "Aplicação de assinatura",
    action: "APPLY",
    icon: "ph-check",
    color: "success",
    description: "{AUTHOR} aplicou assinatura de email para {IMPACTED_USERS}",
    getDescription: getEmailLogsDescription,
  },
  request_email_signature: {
    event: "Solicitação de aplicação",
    action: "REQUESTED",
    icon: "ph-envelope-simple-open",
    color: "accent",
    description:
      "{AUTHOR} solicitou aplicação da assinatura de e-mail para os usuários: {IMPACTED_USERS}",
    getDescription: getEmailLogsDescription,
  },
  default_signature_for_new_user: {
    event: "Assinatura para novos usuários",
    action: "APPLY",
    icon: "ph-check",
    color: "success",
    description:
      "Assinatura para novos usuários foi aplicada automaticamente para {IMPACTED_USERS}",
    getDescription: getEmailLogsDescription,
  },
  reapply_email_signature: {
    event: "Reaplicação de assinatura",
    action: "REAPPLY",
    icon: "ph-check",
    color: "success",
    description:
      "{AUTHOR} reaplicou a assinatura de email para {IMPACTED_USERS}",
    getDescription: getEmailLogsDescription,
  },
  apply_secondary_email_signature: {
    event: "Aplicação de assinatura no email secundário",
    action: "APPLY",
    icon: "ph-check",
    color: "success",
    description:
      "{AUTHOR} aplicou a assinatura no email secundário para {IMPACTED_USERS}",
    getDescription: getEmailLogsDescription,
  },
  declined_signature: {
    event: "Aplicação de assinatura",
    action: "DECLINED",
    icon: "ph-fill ph-backspace",
    color: "error",
    description:
      "{AUTHOR} rejeitou aplicar a assinatura solicitada por {IMPACTED_USERS}",
    getDescription: getEmailLogsDescription,
  },
  accepted_signature: {
    event: "Aplicação de assinatura",
    action: "ACCEPTED",
    icon: "ph-check",
    color: "success",
    description:
      "{AUTHOR} aceitou aplicar a assinatura solicitada por {IMPACTED_USERS}",
    getDescription: getEmailLogsDescription,
  },
  add_new_user: {
    event: "Criação de usuário",
    action: "ADD_NEW_USER",
    icon: "ph-plus-circle",
    color: "success",
    description: "{AUTHOR} criou {USER}",
    getDescription: getUserLogDescription,
  },
  onboarding_new_user: {
    event: "Criação de usuário",
    action: "ADD_NEW_USER",
    icon: "ph-plus-circle",
    color: "success",
    description: "{AUTHOR} criou {USER}",
    getDescription: getOnboardingUserLogDescription,
  },
  sync_user_data: {
    action: "SYNC_USER_DATA",
    icon: "ph-arrows-clockwise",
    color: "accent",
    description: "",
    getDescription: translateDescription,
  },
  update_user: {
    event: "Atualização de usuário",
    action: "UPDATE_USER",
    icon: "ph-pencil-simple",
    color: "accent",
    description: "{AUTHOR} atualizou {USER}",
    getDescription: getUserLogDescription,
  },
  delete_user: {
    event: "Exclusão de usuário",
    action: "DELETE_USER",
    icon: "ph-minus-circle",
    color: "error",
    description: "{AUTHOR} Excluiu {USER}",
    getDescription: getUserLogDescription,
  },
  verify_phone: {
    event: "Exclusão de usuário",
    action: "",
    icon: "",
    color: "",
    description: "Telefone {PHONE} enviado para verificação",
    getDescription: getVerifyPhoneLogDescription,
  },
  user_permission: {
    event: "Permissão de usuário",
    action: "",
    icon: "",
    color: "",
    descriptionAdd:
      "O usuário {USER} recebeu a permissão de gerente para {PRODUCT}",
    descriptionRemove:
      "A permissão de gerente para {PRODUCT}, foi removida do usuário {USER}",
    getDescription: getUserPermissioneLogDescription,
  },
  migrate_emails: {
    event: "Migração de e-mails",
    action: "",
    icon: "",
    color: "",
    getDescription: getEmailMigrationLogDescription,
  },

  vacation_apply: {
    event: "Aplicação de férias",
    action: "APPLY",
    icon: "ph-check",
    color: "success",
    description: "{AUTHOR} aplicou férias para: {IMPACTED_USERS}",
    getDescription: getVacationLogsDescription,
  },

  vacation_apply_batch: {
    event: "Aplicação de férias",
    action: "APPLY",
    icon: "ph-check",
    color: "success",
    description: "{AUTHOR} aplicou férias para: {IMPACTED_USERS}",
    getDescription: getVacationLogsDescription,
  },

  stop_migration: {
    event: LOG_CONTEXT.stop_migration,
    action: "STOP",
    icon: "ph-prohibit",
    color: "grey",
    description: "",
    getDescription: getMigrationLogsDescription,
  },
};

export const LOG_ACTION = {
  DELETE: "Exclusão",
  CREATE: "Criação",
  UPDATE: "Atualização",
  EDIT_TAGS: "Edição",
  EDITED_USER_TAGS: "Edição",
  SYNC_USER_DATA: "Sincronização",
  EDIT: "Edição",
  APPLY: "Aplicação",
  REAPPLY: "Reaplicação",
  EDIT_USER_TAGS: "Edição",
  DECLINED: "Recusado",
  ACCEPTED: "Aceito",
  REQUESTED: "Solicitação",
  ADD_NEW_USER: "Criação",
  UPDATE_USER: "Sincronização externa",
  DELETE_USER: "Exclusão",
  SUCCESS: "Sucesso",
  REALESED_FOR_TIME_EXPIRED: "Tempo excedido",
  SKIP_VERIFICATION: "Verificação adiada",
  CODE_SENT: "Código enviado",
  INVALID_CODE: "Código inválido",
  EXPIRED_CODE: "Código expirado",
  UNKNOWN_ERROR: "Erro desconhecido",
  TOO_MANY_REQUESTS: "Muitas tentativas",
  NOT_FOUND: "Não encontrado",
  REMOVE_USER_PERMISSION: "Removeu",
  ADD_USER_PERMISSION: "Concedeu",
  RUNNING: i18n.t("common.running"),
  IN_PROGRESS: i18n.t("common.running"),
  CANCELED: i18n.t("common.canceled"),
  INTERRUPTED: i18n.t("common.interrupted"),
  FINISHED: i18n.t("common.finished"),
  COMPLETED: i18n.t("common.finished"),
  FAILED: i18n.t("common.failed"),
  ERROR: "Ocorreu um erro",
  STOP: "Parar",
};
